export default __webpack_public_path__ + "static/media/flower-8.f22cd6cd.png";